import React from 'react';

export function Shortcut({ children, className = '' }: React.ComponentProps<'span'>) {
  return (
    <code className={[
      'font-mono font-bold',
      'bg-gray-200 text-gray-700 ring-2 ring-gray-400',
      'py-1 px-2 mx-2 rounded-md',
      className
    ].join(' ')}>
      {children}
    </code>
  );
}
